<template>
  <div id="app">
    <div v-if="$root.isIE" id="ie-error" class="v-align" v-html="$t('_ie_not_allowed')" />
    <div>
      <bandeau />
    </div>
    <router-view />
  </div>
</template>

<script>

// import '@/assets/hiding-columns'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import '@fortawesome/fontawesome-free/scss/regular.scss'
import '@fortawesome/fontawesome-free/scss/brands.scss'
import CommonApi from '@/api/commonApi'
import bandeau from '@/components/frontoffice/bandeau'


export default {
  name: 'app',
  data () {
    return {
      commonApi: new CommonApi()
    }
  },
  created () {
    /*
    this.commonApi.getNbUnreadNews()
      .then(response => {
        this.$store.commit('news/update', response.data)
      })
	*/
  },
  components: {
    bandeau
  }
}



</script>

<style lang="scss">
    @import '@/assets/sass/app.scss';
    @import '@/assets/sass/frontoffice/main.scss'; //import directement ici en raison d'un problème de feuille de style car certaines modal sont hors de la main class front-layout
  #ie-error {
    position: fixed;
    top: 0;
    background-color: darkred;
    color: white;
    width: 100%;
    height: 2rem;
    z-index: 99999999999;
    padding-left: 1rem;

    a {
      color: white;
      font-weight: bold;
      text-decoration: underline;
    }
  }
</style>
